import WebViewer from "@pdftron/webviewer";
import { useEffect, useRef, useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const ViewVoucher = ({ fileName }) => {

  const viewRef = useRef();
  const [url, setUrl] = useState();
  const [extension, setExtension] = useState();

  useEffect(() => {
    handleViewAttachment();
  }, [])

  const handleViewAttachment = async () => {
    try {
      debugger
      const downloadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileDownload}`;
      const download = await OAuthService.getDownload(
        downloadUrl + `/${fileName}`
      );
      const blob = download?.data;
      if (blob) {
        const url = window.URL.createObjectURL(
          new Blob([blob], { type: "application/octet-stream" })
        );
        setUrl(url);
        const arr = fileName.split('.');
        const extension = arr[arr.length - 1]?.toLowerCase();
        setExtension(extension);
        if (extension === 'pdf') {
          WebViewer(
            {
              path: 'lib',
              initialDoc: url,
            },
            viewRef.current
          )
        }

      }
    } catch (error) { }

  };

  return (
    <>
        <div ref={viewRef} style={{ height: extension === 'pdf' ? '100vh' : '' }}></div>
        {extension !== 'pdf' && (<div style={{display: 'flex', justifyContent: 'center'}}>
          <img src={url} />
        </div>
      )}
    </>
  )
}
export default ViewVoucher;